import PropTypes from 'prop-types';
import { getPatientStatus } from 'utils';

const StatusIndicator = ({ status }) => {
  const { label, color } = getPatientStatus(status);
  return (
    <div style={{ backgroundColor: color }} className="status-indicator">
      {label}
    </div>
  );
};

StatusIndicator.propTypes = {
  status: PropTypes.string,
};

export default StatusIndicator;
